import React from 'react';

interface DotIndicatorProps {
	dotNumber: number;
	className?: string;
}

const DotIndicator: React.FC<DotIndicatorProps> = ({ dotNumber, className }) => (
	<div className={`${className}`}>
		<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" className="size-[16px] text-info-600 dark:text-info-400 fill-current">
			<circle cx="50" cy="50" r="50" />
			<text x="50%" y="50%" textAnchor="middle" dominantBaseline="central" fontSize="70" className="text-white dark:text-black font-bold">
				{dotNumber}
			</text>
		</svg>
	</div>
);

export default DotIndicator;
